var ebere;
(function($) {
  "use strict";
  ebere = (function() {
    return {
      init: function() {
        // Header
        this.popupSearch();
        this.mobileMenu();
        this.cart();

        // Home default
        this.homeDefaultSlider();
        this.homeOurProducts();

        // Home full width
        this.homeFullWidthCanvasMenu();
        this.homeFullWidthCart();
        this.homeFullWidthSlider();

        // Home modern

        // Home collection
        this.homeCollectionSlider();

        // Home dark
        this.homeDarkSlider();
        this.homeDarkTestimonials();

        // Home classic
        this.homeClassicOurProducts();

        // Home best selling
        this.homeBestSellingSlider();

        // Home sidebar
        this.homeSideBarTestimonials();

        // Home minimal
        this.homeMinimalSlider();
        this.homeMinimalInstagram();

        // Home shoppable
        this.homeShoppableMainBanner();

        // Product grid item
        this.productGridItemImages();

        // Product list item
        this.productListItemImages();

        // Collection
        this.collectionFilter();
        this.collection();

        // Blog
        this.blog();

        // Account
        this.accountLogin();

        // Product
        this.productImages();
        this.productMobileImages();
        this.productRelatedProducts();
        this.productStickyAddToCart();
        this.relatedProducts();
        this.shareProduct();
        this.askQuestion();
        this.productForm();
        this.productFrequentlyBoughtTogether();

        // Utilities
        this.videoPopup();
        this.countDown();
        this.quantity();
        this.tabs();
        this.accordion();
        this.rating();
        this.background();
        this.backgroundParallax();
        this.zoom();
        this.wishlist();
        this.compare();
        this.sizeGuide();
        this.quickView();
      },

      // Header
      popupSearch: function() {
        $(".js-open-popup-search").on("click", function() {
          $(".js-search-popup").addClass("active");
          return false;
        });
        $(".js-close-search-popup").on("click", function() {
          $(".js-search-popup").removeClass("active");
          return false;
        });
      },

      mobileMenu: function() {
        $('.js-mobile-menu-dropdown-btn').on("click", function() {
          $(this).parent().find('.js-mobile-menu-dropdown-menu').slideToggle(500);
        });
        $(".js-open-mobile-menu").on("click", function() {
          $(".js-mobile-menu").addClass("active");
          $("body").css("overflow", "hidden");
          return false;
        });
        $(".js-close-mobile-menu").on("click", function() {
          $(".js-mobile-menu").removeClass("active");
          $("body").css("overflow", "visible");
          return false;
        });
      },

      cart: function() {
        $("body").on("click", ".js-delete-product", function() {
          var variantId = parseInt($(this).attr("data-variant-id"));
          var quantity = 0;
          $(".js-cart-content").addClass("is-loading");
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { id: variantId, quantity: quantity },
            success: function() {
              ebere.refreshCartDefault();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              ebere.refreshCartDefault();
            }
          });
          return false;
        });
        $("body").on("click", ".js-delete-product-canvas", function() {
          var variantId = parseInt($(this).attr("data-variant-id"));
          var quantity = 0;
          $(".js-cart-content").addClass("is-loading");
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { id: variantId, quantity: quantity },
            success: function() {
              ebere.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              ebere.refreshCart();
            }
          });
          return false;
        });
        $("body").on("click", ".js-change-quantity", function() {
          var variantId = parseInt($(this).attr("data-variant-id"));
          var quantity = parseInt($(this).attr("data-quantity"));
          $(".js-cart-content").addClass("is-loading");
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { id: variantId, quantity: quantity },
            success: function() {
              ebere.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              ebere.refreshCart();
            }
          });
          return false;
        });
      },

      // Home default
      homeDefaultSlider: function() {
        $('.js-home-default-slider').slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          fade: true,
          arrows: false
        });
        setTimeout(function () {
          $('.js-slider-tag, .js-slider-heading, .js-slider-description, .js-slider-action, .js-slider-image, .js-slider-price, .js-slider-second-heading').addClass("is-active");
        }, 100);
        $('.js-slider-prev').on("click", function() {
          $(this).parent().parent().parent().find('.slick-slider').slick('slickPrev');
        });
        $('.js-slider-next').on("click", function() {
          $(this).parent().parent().parent().find('.slick-slider').slick('slickNext');
        });
      },

      homeOurProducts: function() {
        $('.js-home-our-products').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: true,
          infinite: false,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 1499,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      },

      // Home full width
      homeFullWidthCanvasMenu: function() {
        $(".js-open-canvas-menu").on("click", function() {
          $(".js-canvas-menu").addClass("active");
          $("body").css("overflow", "hidden");
          return false;
        });
        $(".js-close-canvas-menu").on("click", function() {
          $(".js-canvas-menu").removeClass("active");
          $("body").css("overflow", "visible");
          return false;
        });
      },

      homeFullWidthCart: function() {
        $(".js-open-canvas-cart").on("click", function() {
          $(".js-canvas-cart").addClass("active");
          $("body").css("overflow", "hidden");
          return false;
        });
        $("body").on("click", ".js-close-canvas-cart", function() {
          $(".js-canvas-cart").removeClass("active");
          $("body").css("overflow", "visible");
          return false;
        });
      },

      homeFullWidthSlider: function() {
        $('.js-home-full-width-slider').slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          fade: true,
          arrows: true
        });
        $(".js-slider-item-thumbnail").on("click", function() {
          var id = $(this).attr("data-id");
          var sliderId = $(this).attr("data-slider-id");
          $(".js-slider-item[data-id='" + sliderId + "']").find(".js-slider-item-thumbnail").removeClass("active");
          $(this).addClass("active");
          $(".js-slider-item[data-id='" + sliderId + "']").find(".js-slider-item-image").removeClass("active");
          $(".js-slider-item[data-id='" + sliderId + "']").find(".js-slider-item-image[data-id='" + id + "']").addClass("active");
          return false;
        });
      },

      // Home collection
      homeCollectionSlider: function() {
        $('.js-home-collection-slider').slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          fade: true,
          arrows: true
        });
      },

      // Home dark
      homeDarkSlider: function() {
        $('.js-home-dark-slider').slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          fade: true,
          arrows: true
        });
      },

      homeDarkTestimonials: function() {
        $('.js-dark-testimonials').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      },

      // Home classic
      homeClassicOurProducts: function() {
        $('.js-home-classic-our-products').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          infinite: false,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 1499,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
        $('.js-home-classic-our-products-2').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: true,
          infinite: false,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 1499,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      },

      // Home best selling
      homeBestSellingSlider: function() {
        $('.js-home-best-selling-slider').slick({
          dots: true,
          vertical: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          arrows: false
        });
      },

      // Home sidebar 
      homeSideBarTestimonials: function() {
        $('.js-sidebar-testimonials').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      },

      // Home minimal
      homeMinimalSlider: function() {
        $('.js-home-minimal-slider').slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          fade: true,
          arrows: true
        });
        if($('.js-home-minimal-slider').length > 0) {
          $(".minimal-slider .slick-prev").css("left", $(".minimal-slider__feature").offset().left);
          $(".minimal-slider .slick-next, .minimal-slider .slick-dots").css("right", $(".minimal-slider__feature").offset().left);
          $(window).resize(function() {
            setTimeout(function () {
              $(".minimal-slider .slick-prev").css("left", $(".minimal-slider__feature").offset().left);
              $(".minimal-slider .slick-next, .minimal-slider .slick-dots").css("right", $(".minimal-slider__feature").offset().left);
            }, 200);
          });
        }
      },

      homeMinimalInstagram: function() {
        $('.js-home-minimal-instagram').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          dots: true,
          infinite: false,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 1499,
              settings: {
                slidesToShow: 5
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 3
              }
            }
          ]
        });
      },

      // Home shoppable
      homeShoppableMainBanner: function() {
        $(".js-open-pin").on("click", function() {
          var id = $(this).attr("data-id");
          $(".js-pin-content[data-id='" + id + "']").addClass("active");
          return false;
        });
        $(".js-close-pin").on("click", function() {
          var id = $(this).attr("data-id");
          $(".js-pin-content[data-id='" + id + "']").removeClass("active");
          return false;
        });
      },

      // Product grid item
      productGridItemImages: function() {
        $("body").on("click", ".js-product-grid-previous-image", function() {
          var currentImage = parseInt($(this).parent().parent().parent().find(".js-product-grid-images").attr("data-current-image"));
          var previousImage = currentImage - 1;
          var totalImages = parseInt($(this).parent().parent().parent().find(".js-product-grid-image").length) - 1;
          $(this).parent().parent().parent().find(".js-product-grid-image").removeClass("active");
          if(previousImage >= 0) {
            $(this).parent().parent().parent().find(".js-product-grid-image").eq(previousImage).addClass("active");
            $(this).parent().parent().parent().find(".js-product-grid-images").attr("data-current-image", previousImage);
          } else {
            $(this).parent().parent().parent().find(".js-product-grid-image").eq(totalImages).addClass("active");
            $(this).parent().parent().parent().find(".js-product-grid-images").attr("data-current-image", totalImages);
          }
        });
        $("body").on("click", ".js-product-grid-next-image", function() {
          var currentImage = parseInt($(this).parent().parent().parent().find(".js-product-grid-images").attr("data-current-image"));
          var nextImage = currentImage + 1;
          $(this).parent().parent().parent().find(".js-product-grid-image").removeClass("active");
          if($(this).parent().parent().parent().find(".js-product-grid-image").eq(nextImage).length > 0) {
            $(this).parent().parent().parent().find(".js-product-grid-image").eq(nextImage).addClass("active");
            $(this).parent().parent().parent().find(".js-product-grid-images").attr("data-current-image", nextImage);
          } else {
            $(this).parent().parent().parent().find(".js-product-grid-image").eq(0).addClass("active");
            $(this).parent().parent().parent().find(".js-product-grid-images").attr("data-current-image", 0);
          }
        });
      },

      // Product list item
      productListItemImages: function() {
        $(".js-product-list-previous-image").on("click", function() {
          var currentImage = parseInt($(this).parent().parent().parent().find(".js-product-list-images").attr("data-current-image"));
          var previousImage = currentImage - 1;
          var totalImages = parseInt($(this).parent().parent().parent().find(".js-product-list-image").length) - 1;
          $(this).parent().parent().parent().find(".js-product-list-image").removeClass("active");
          if(previousImage >= 0) {
            $(this).parent().parent().parent().find(".js-product-list-image").eq(previousImage).addClass("active");
            $(this).parent().parent().parent().find(".js-product-list-images").attr("data-current-image", previousImage);
          } else {
            $(this).parent().parent().parent().find(".js-product-list-image").eq(totalImages).addClass("active");
            $(this).parent().parent().parent().find(".js-product-list-images").attr("data-current-image", totalImages);
          }
        });
        $(".js-product-list-next-image").on("click", function() {
          var currentImage = parseInt($(this).parent().parent().parent().find(".js-product-list-images").attr("data-current-image"));
          var nextImage = currentImage + 1;
          $(this).parent().parent().parent().find(".js-product-list-image").removeClass("active");
          if($(this).parent().parent().parent().find(".js-product-list-image").eq(nextImage).length > 0) {
            $(this).parent().parent().parent().find(".js-product-list-image").eq(nextImage).addClass("active");
            $(this).parent().parent().parent().find(".js-product-list-images").attr("data-current-image", nextImage);
          } else {
            $(this).parent().parent().parent().find(".js-product-list-image").eq(0).addClass("active");
            $(this).parent().parent().parent().find(".js-product-list-images").attr("data-current-image", 0);
          }
        });
      },

      // Collection
      collectionFilter: function() {
        $(".js-open-collection-filter").on("click", function(){
          $(this).toggleClass('active');
          $(".js-top-filter").slideToggle('');
        });
        $(".js-open-mobile-filter").on("click", function() {
          $(".js-top-filter").addClass("active");
          setTimeout(function () {
            $(".js-top-filter").addClass("show");
          }, 100);
          return false;
        }); 
        $(".js-close-filter").on("click", function() {
          $(".js-top-filter").removeClass("show");
          setTimeout(function () {
            $(".js-top-filter").removeClass("active");
          }, 300);
          return false;
        });
        if ($(".js-price-slider").length) {
          $(".js-price-slider").slider({
            range: true,
            min: 100,
            max: 3000,
            values: [ 100, 1500 ],
            slide: function( event, ui ) {
              $(".js-price-slider-value").val("$" + ui.values[ 0 ] + " - $" + ui.values[ 1 ]);
            }
          });
          if($(".js-price-slider-value").length) {
            $(".js-price-slider-value").val("$" + $(".js-price-slider").slider("values", 0) + " - $" + $(".js-price-slider").slider("values", 1));
          };
        }
        
        Shopify.queryParams = {};
        Shopify.queryParams.sort_by = $(".js-collection-sort-by").val();
        var tags = [];
        $("input.tag").each(function () {
          if($(this).is(":checked")) {
            tags.push($(this).attr("value"));
          }
        });
        Shopify.queryParams.constraint = tags.join("+");

        function filterCreateUrl() {
          if(Shopify.queryParams.constraint == '') {
            return $(".js-collection-items").attr("data-url") + "?sort_by=" + Shopify.queryParams.sort_by + "&view=" + $(".js-collection-items").attr("data-view");
          } else {
            return $(".js-collection-items").attr("data-url") + "/" + Shopify.queryParams.constraint + "?sort_by=" + Shopify.queryParams.sort_by + "&view=" + $(".js-collection-items").attr("data-view");
          }
        }

        function filterGetContent(url) {
          $.ajax({
            type: "get",
            url: url,
            beforeSend: function() {
              $(".js-collection").addClass("loading");
            },
            success: function(result) {
              var title = result.match("<title>(.*?)</title>")[1];
              History.pushState({
                param: Shopify.queryParams
              }, title, url);
              $(".js-collection").html($(result).find(".js-collection").html());
              $(".js-collection").removeClass("loading");
            },
            error: function() {
              $(".js-collection").removeClass("loading");
            }
          })
        }

        $("input.tag").change(function () {
          var tags = [];
          $("input.tag").each(function () {
            if($(this).is(":checked")) {
              tags.push($(this).attr("value"));
            }
          });
          Shopify.queryParams.constraint = tags.join("+");
          filterGetContent(filterCreateUrl());
          return false;
        });

        $("body").on("change", ".js-collection-sort-by", function(y) {
          Shopify.queryParams.sort_by = $(".js-collection-sort-by").val();
          filterGetContent(filterCreateUrl());
          return false;
        });
      },

      collection: function() {
        $(window).scroll(function() {
          if($(".js-collection-next-page").length > 0) {
            var scrollTop = $(window).scrollTop();
            if(scrollTop > $(".js-collection-next-page").offset().top - $(window).outerHeight() - 100) { 
              var href = $(".js-collection-next-page").attr("data-href");
              $(".js-collection-pagination").removeClass("js-collection-next-page");
              $.ajax({
                url: href,
                type: 'GET'
              }).done(function(data) {
                $(".js-collection-pagination").remove();
                $('.js-collection-row').append($(data).find('.js-collection-row').html());
              })
            }
          }
        });
      },

      // Blog
      blog: function() {
        $('.js-featured-articles').slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          fade: true,
          arrows: false
        });
        $('.js-latest-articles').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
        $("body").on("click", ".js-blog-next-page", function () {
          var href = $(this).attr("data-href");
          $(this).parent().remove();
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $('.js-blog-row').append($(data).find('.js-blog-row').html());
          })
          return false;
        });
      },

      // Account
      accountLogin: function() {
        $(".js-go-to-forgotten-password").click(function () {
          $(".js-login").addClass("d-none");
          $(".js-forgotten-password").removeClass("d-none");
          return false;
        });
        $(".js-back-to-login").click(function () {
          $(".js-login").removeClass("d-none");
          $(".js-forgotten-password").addClass("d-none");
          return false;
        });
      },

      // Product
      productImages: function() {
        $(".js-product-thumbnail").on("click", function() {
          var id = $(this).attr("data-id");
          $(".js-product-thumbnail").removeClass("active");
          $(this).addClass("active");
          $(".js-product-main-image").removeClass("active");
          $(".js-product-main-image[data-id='" + id + "']").addClass("active");
          ebere.zoom();
          if($(".js-product-layout-2").length > 0) {
            $("html, body").stop().animate({scrollTop: $(".js-product-main-image[data-id='" + id + "']").offset().top}, 500);
          }
          return false;
        });
        $(".js-popup-gallery a").jqPhotoSwipe({
          forceSingleGallery: true
        });
        $(".js-product-mobile-gallery a").jqPhotoSwipe({
          forceSingleGallery: true
        });
        $(".js-product-thumbnails-prev").on("click", function() {
          var currentGroup = $(this).attr("data-current-group");
          var allGroups = $(this).attr("data-groups");
          if(currentGroup == 1) {
            currentGroup = allGroups;
          } else {
            currentGroup--;
          }
          $(this).attr("data-current-group", currentGroup);
          $(".js-product-thumbnails-next").attr("data-current-group", currentGroup);
          $(".js-product-thumnail-slider").addClass("d-none");
          $(".js-product-thumnail-slider[data-group='" + currentGroup + "']").removeClass("d-none");
          return false;
        });
        $(".js-product-thumbnails-next").on("click", function() {
          var currentGroup = $(this).attr("data-current-group");
          var allGroups = $(this).attr("data-groups");
          if(currentGroup == allGroups) {
            currentGroup = 1;
          } else {
            currentGroup++;
          }
          $(this).attr("data-current-group", currentGroup);
          $(".js-product-thumbnails-prev").attr("data-current-group", currentGroup);
          $(".js-product-thumnail-slider").addClass("d-none");
          $(".js-product-thumnail-slider[data-group='" + currentGroup + "']").removeClass("d-none");
          return false;
        });
      },

      productMobileImages: function() {
        $('.js-product-mobile-gallery').not('.slick-initialized').slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          arrows: true
        });
      },

      productRelatedProducts: function() {
        $('.js-related-products').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 1399,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });
      },

      shareProduct: function() {
        $(".js-share-twitter").click(function () {
          $("a[data-icon='twitter']").click();
          return false;
        });
        $(".js-share-facebook").click(function () {
          $("a[data-icon='fb']").click();
          return false;
        });
      },

      productStickyAddToCart: function() {
        if($(".js-product-action").length > 0) {
          $(window).scroll(function() {
            var scrollTop = $(window).scrollTop();
            if($(".js-product-out-of-stock").hasClass("d-none")) {
              if(scrollTop > $(".js-product-action").offset().top + $(".js-product-action").outerHeight()) { 
                $(".js-sticky-add-to-cart").addClass("active");
              } else {
                $(".js-sticky-add-to-cart").removeClass("active");
              }
            } else {
              if(scrollTop > $(".js-product-out-of-stock").offset().top + $(".js-product-out-of-stock").outerHeight()) { 
                $(".js-sticky-add-to-cart").addClass("active");
              } else {
                $(".js-sticky-add-to-cart").removeClass("active");
              }
            }
          });
        }
      },

      relatedProducts: function() {
        if($(".product-recommendations").length > 0) {
          loadRelatedProducts();
        }
        function loadRelatedProducts() {
          var productRecommendationsSection = document.querySelector(".product-recommendations");
          if (productRecommendationsSection === null) { return; }
          var productId = $(".product-recommendations").attr("data-product-id");
          var limit = $(".product-recommendations").attr("data-limit");
          var requestUrl = "/recommendations/products?section_id=related_products&limit="+limit+"&product_id="+productId;
          var request = new XMLHttpRequest();
          request.open("GET", requestUrl);
          request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
              var container = document.createElement("div");
              container.innerHTML = request.response;
              productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
              ebere.productRelatedProducts();
              if($(".js-related-product").length == 0) {
                $(".js-wrap-related-products").hide();
              }
            }
          };
          request.send();
        }
      },

      askQuestion: function() {
        $(".js-ask-question").click(function () {
          var value = $(this).parent().parent().find(".js-ask-question-body").val();
          value += '\n\nProduct: ' + $(".js-product-title").html();
          $(this).parent().parent().find(".js-ask-question-body").val(value);
        });
      },

      productForm: function() {
    function variants(productId) {
        var data = JSON.parse(document.getElementById('ProductJson' + productId + '').innerHTML);
        var selectCallback = function(variant, selector) {
            var that = $(".js-product[data-product-id='" + productId + "']");
            if (variant) {
                if (variant.available) {
                    $(that).find(".js-product-add-to-cart").removeClass("d-none");
                    $(".js-sticky-add-to-cart-button").removeClass("d-none");
                    $(that).find(".js-product-out-of-stock").addClass("d-none");
                    $(".js-sticky-out-of-stock").addClass("d-none");
                    $(that).find(".js-in-stock").removeClass("d-none");
                    $(that).find(".js-out-of-stock").addClass("d-none");
                } else {
                    $(that).find(".js-product-add-to-cart").addClass("d-none");
                    $(".js-sticky-add-to-cart-button").addClass("d-none");
                    $(that).find(".js-product-out-of-stock").removeClass("d-none");
                    $(".js-sticky-out-of-stock").removeClass("d-none");
                    $(that).find(".js-in-stock").addClass("d-none");
                    $(that).find(".js-out-of-stock").removeClass("d-none");
                }
                if (variant.compare_at_price > variant.price) {
                    $(that).find(".js-price-old").removeClass("d-none").html(Shopify.formatMoney(variant.compare_at_price));
                    $(that).find(".js-price-new").removeClass("d-none").html(Shopify.formatMoney(variant.price));
                    $(that).find(".js-price-default").addClass("d-none");
                } else {
                    $(that).find(".js-price-old, .js-price-new").addClass("d-none");
                    $(that).find(".js-price-default").removeClass("d-none").html(Shopify.formatMoney(variant.price));
                }
                $(".js-sticky-product-price").html(Shopify.formatMoney(variant.price));
                if (variant.featured_image !== null) {
                    $(that).find(".js-product-thumbnail[data-id='" + variant.featured_image.position + "']").click();
                    var groupId = $(that).find(".js-product-thumbnail[data-id='" + variant.featured_image.position + "']").parent().attr("data-group");
                    $(that).find(".js-product-thumnail-slider").addClass("d-none");
                    $(that).find(".js-product-thumnail-slider[data-group='" + groupId + "']").removeClass("d-none");
                    $(that).find(".js-product-thumbnails-prev, .js-product-thumbnails-next").attr("data-current-group", groupId);
                    $('.js-product-mobile-gallery[data-product-id="' + productId + '"]').slick('slickGoTo', variant.featured_image.position - 1);
                    $(".js-sticky-product-image").attr("src", $(that).find(".js-product-thumbnail[data-id='" + variant.featured_image.position + "'] img").attr("src"));
                }
            } else {
                $(that).find(".js-product-add-to-cart").addClass("d-none");
                $(".js-sticky-add-to-cart-button").addClass("d-none");
                $(that).find(".js-product-out-of-stock").removeClass("d-none");
                $(".js-sticky-out-of-stock").removeClass("d-none");
            }
        }
        jQuery(function($) {
            if ($("#product-select-" + productId + "").length > 0) {
                new Shopify.OptionSelectors("product-select-" + productId + "", { product: data, onVariantSelected: selectCallback, enableHistoryState: true });
            }
        });
    }

    $(".js-product").each(function () {
        variants($(this).attr("data-product-id"));
    });

    $(".js-product-select").on("change", function () {
        var option = $(this).attr("data-option");
        var value = $(this).val();
        var productId = $(this).attr("data-product-id");
        $(".js-sticky-product-option[data-option='" + option + "']").html(value);
        $(".js-product[data-product-id='" + productId + "'] #product-variants select[data-option='" + option + "']").val(value).change();
        return false;
    });

    $(".js-product-color").click(function () {
        $(this).parent().parent().find("li").removeClass("active");
        $(this).parent().addClass("active");
        var option = $(this).parent().parent().attr("data-option");
        var value = $(this).attr("data-value");
        var productId = $(this).attr("data-product-id");
        $(".js-product[data-product-id='" + productId + "'] .js-product-color-value[data-option='" + option + "']").html(value);
        $(".js-sticky-product-option[data-option='" + option + "'] p").attr("data-color", value);
        $(".js-sticky-product-option[data-option='" + option + "'] span").html(value);
        $(".js-product[data-product-id='" + productId + "'] #product-variants select[data-option='" + option + "']").val(value).change();
        return false;
    });

    $(".js-product-value").click(function () {
        $(this).parent().parent().find("a").removeClass("active");
        $(this).addClass("active");
        var option = $(this).parent().parent().attr("data-option");
        var value = $(this).attr("data-value");
        var productId = $(this).attr("data-product-id");
        $(".js-product[data-product-id='" + productId + "'] #product-variants select[data-option='" + option + "']").val(value).change();
        return false;
    });

    $("body").on("click", ".js-add-to-cart", function () {
        $(this).addClass("is-loading");
        if ($(this).hasClass("variant")) {
            var quantity = 1;
            var id = $(this).attr("data-variant-id");
            var properties = {};
        } else {
            var productId = $(this).attr("data-product-id");
            var quantity = $(".js-product[data-product-id='" + productId + "'] .js-quantity-field").val();
            if (isNaN(quantity)) { quantity = 1; }
            var id = $(".js-product[data-product-id='" + productId + "'] #product-select-" + productId + "").val();
            var properties = {};
            $(".js-product[data-product-id='" + productId + "'] input, .js-product[data-product-id='" + productId + "'] select, .js-product[data-product-id='" + productId + "'] textarea").each(function () {
                var getName = $(this).attr("name");
                if (typeof getName !== 'undefined') {
                    if (getName.indexOf("properties") >= 0) {
                        var name = $(this).attr("name").replace("properties[", "").replace("]", "");
                        var value = $(this).val();
                        properties[name] = value;
                    }
                }
            });
        }
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: id, quantity: quantity, properties: properties },
            success: function() {
                ebere.refreshCart();
            },
            error: function(response) {
                var errorMessage = response.responseJSON
                    ? response.responseJSON.description
                    : theme.strings.cartError;
                alert(errorMessage);
                ebere.refreshCart();
            }
        });
        return false;
    });

    $("body").on("click", ".js-add-to-cart-sticky", function () {
        $(this).addClass("is-loading");
        var productId = $(this).attr("data-product-id");
        var quantity = $(this).parent().parent().find(".js-quantity-field").val();
        if (isNaN(quantity)) { quantity = 1; }
        var id = $(".js-product[data-product-id='" + productId + "'] #product-select-" + productId + "").val();
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: id, quantity: quantity },
            success: function() {
                ebere.refreshCart();
            },
            error: function(response) {
                var errorMessage = response.responseJSON
                    ? response.responseJSON.description
                    : theme.strings.cartError;
                alert(errorMessage);
                ebere.refreshCart();
            }
        });
        return false;
    });
},

      productFrequentlyBoughtTogether: function() {
        $(".js-add-all-to-cart").click(function () {
          var s = 0;
          $(this).addClass("is-loading");
          var countProducts = 0;
          $(".js-frequently-bought-together-product").each(function () {
            if($(this).is(":checked")) {
              countProducts++;
            }
          });
          var countAddedProducts = 0;
          $(".js-frequently-bought-together-product").each(function () {
            if($(this).is(":checked")) {
              var id = $(this).attr("data-variant-id");
              s++;
              var timeout = 1000*s;
              setTimeout(function () {
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  dataType: 'json',
                  data: { id: id, quantity: 1 },
                  success: function() {
                    countAddedProducts++;
                    if(countAddedProducts >= countProducts) {
                      ebere.refreshCart();
                      $(".js-add-all-to-cart").removeClass("is-loading");
                    }
                  },
                  error: function(response) {
                    var errorMessage = response.responseJSON
                      ? response.responseJSON.description
                      : theme.strings.cartError;
                    alert(errorMessage);
                  }
                });
              }, timeout);
            }
          });
          return false;
        });
        $(".js-add-all-to-wishlist").click(function () {
          if(!$(this).hasClass("added")) {
            $(this).addClass("added");
            $(this).html($(this).attr("data-added"));
            $(".js-frequently-bought-together-product").each(function () {
              var productHandle = $(this).attr("data-product-handle");
              var getWishlistProducts = localStorage.getItem('wishlist');
              if(getWishlistProducts == null) { getWishlistProducts = ''; }
              getWishlistProducts = getWishlistProducts.replace(productHandle + ",", "");
              localStorage.setItem('wishlist', getWishlistProducts + productHandle + ",");
            });
            return false;
          }
        });
      },

      // Utilities
      videoPopup: function() {
        $('.js-video-popup').magnificPopup({
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false
        });
      },

      countDown: function() {
        $(".js-countdown").each(function () {
          var that = $(this);
          setInterval(function () {
            var currentDate = new Date().getTime();
            var deadlineDate = new Date($(that).attr("data-deadline-date")).getTime();
            var distance = deadlineDate - currentDate;
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            $(that).find(".js-countdown-days").html(days);
            $(that).find(".js-countdown-hours").html(hours);
            $(that).find(".js-countdown-minutes").html(minutes);
            $(that).find(".js-countdown-seconds").html(seconds);
          }, 1000);
        });
      },

      quantity: function() {
        $("body").on("click", ".js-quantity-down", function() {
          var q_val_up = parseInt($(this).parent().find(".js-quantity-field").val());
          if(isNaN(q_val_up)) {
            q_val_up = 0;
          }
          if(q_val_up > 0) {
            $(this).parent().find(".js-quantity-field").val(q_val_up-1).keyup();
          } 
          return false; 
        });
        $("body").on("click", ".js-quantity-up", function() {
          var q_val_up = parseInt($(this).parent().find(".js-quantity-field").val());
          if(isNaN(q_val_up)) {
            q_val_up = 0;
          }
          $(this).parent().find(".js-quantity-field").val(q_val_up+1).keyup(); 
          return false; 
        });
      },

      tabs: function() {
        $(".js-open-tab").on("click", function() {
          var id = $(this).attr("data-id");
          $(".js-tab[data-id='" + id + "']").addClass("active");
          return false;
        });
        $(".js-close-tab").on("click", function() {
          $(".js-tab").removeClass("active");
          return false;
        });
        $(".js-tab-link").on("click", function() {
          $(this).parent().parent().find(".js-tab-link").removeClass("active");
          $(this).addClass("active");
          $(this).parent().parent().parent().find(".js-tab-content").removeClass("tab-content__active").removeClass("tab-content__show");
          var that = $(this).parent().parent().parent().find(".js-tab-content[data-id='" + $(this).attr("data-id") + "']");
          $(that).addClass("tab-content__active");
          setTimeout(function () {
            $(that).addClass("tab-content__show");
          }, 100);
          return false;
        });
      },

      accordion: function() {
        $(".js-accordion-title").on("click", function() {
          $(this).parent().parent().find(".js-accordion").removeClass("current");
          $(this).parent().toggleClass("active").addClass("current");
          $(this).parent().parent().find(".js-accordion:not(.current).active .js-accordion-content").slideToggle(500);
          $(this).parent().parent().find(".js-accordion:not(.current).active").removeClass("active");
          $(this).parent().find(".js-accordion-content").slideToggle(500);
        });
        $(".js-accordion.active").each(function () {
          $(this).find(".js-accordion-content").slideToggle(500);
        });
      },

      rating: function() {
        $(".js-rating-content").each(function () {
          var that = $(this);
          $(that).find('.js-rating').on("mouseover", function(){
            var rate = $(this).data('value');
            var i = 0;
            $(that).find('.js-rating').each(function(){
              i++;
              if(i <= rate) {
                $(this).addClass('active');
              } else {
                $(this).removeClass('active');
              }
            });
          });
          $(that).find('.js-rating').on("mouseleave", function(){
            var rate = $(this).parent().find(".js-rating-input:checked").val();
            rate = parseInt(rate);
            var i = 0;
            $(that).find('.js-rating').each(function(){
              i++;
              if(i <= rate){
                $(this).addClass('active');
              } else {
                $(this).removeClass('active');
              }
            });
          });
          $(that).find('.js-rating').on("click", function(){
            $(this).parent().find('.js-rating-input:nth('+ ($(this).data('value')-1) +')').prop('checked', true);
          });
        });
      },

      background: function() {
        $('.js-background').each(function() {
          $(this).css('background-image', 'url('+ $(this).attr('data-background') + ')');
        });
      },

      backgroundParallax: function() {
        if($(document).outerWidth() > 991) {
          $('.js-background-parallax').jarallax({
            speed: 0.3
          });
        }
      },

      zoom: function() {
        for (var i = 1; i < 100; i++) {
          if(i == 1) {
            $('.active .js-zoomit').zoomIt();
          } else {
            $('.active-' + i + ' .js-zoomit').zoomIt();
          }
        }
      },

      wishlist: function() {
        $(".js-add-to-wishlist").each(function () {
          var productHandle = $(this).attr("data-product-handle") + ",";
          var wishlist = localStorage.getItem('wishlist');
          if(wishlist == null) { wishlist = ''; }
          if(wishlist.indexOf(productHandle) >= 0) {
            $(this).find("i").attr("class", "lnil lnil-heart-filled");
            $(this).find("span").html($(this).attr("data-added"));
          }
        });
        $("body").on("click", ".js-add-to-wishlist", function () {
          if(!$(this).find("i").hasClass("lnil-heart-filled")) {
            var productHandle = $(this).attr("data-product-handle");
            $(this).find("i").attr("class", "lnil lnil-heart-filled");
            $(this).find("span").html($(this).attr("data-added"));
            var getWishlistProducts = localStorage.getItem('wishlist');
            if(getWishlistProducts == null) { getWishlistProducts = ''; }
            getWishlistProducts = getWishlistProducts.replace(productHandle + ",", "");
            localStorage.setItem('wishlist', getWishlistProducts + productHandle + ",");
            return false;
          }
        });
        if($(".js-wishlist-body").length > 0) {
          var wishlist = localStorage.getItem('wishlist');
          var wishlistContent = '';
          if(wishlist == null) { wishlist = ''; }
          if(wishlist != '') {
            var wishlistProducts = wishlist.split(",");
            for (let i = 0; i < wishlistProducts.length; i++) {
              if(wishlistProducts[i] != '') {
                jQuery.getJSON('/products/' + wishlistProducts[i] + '.js', function (product) {
                  var first_column = '<td><div class="wishlist__product"><div class="wishlist-product__image"><a href="' + product.url + '"><img alt="Image" data-sizes="auto" data-srcset="' + product.featured_image + ' 400w" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload" /></a></div><h3 class="wishlist-product__title"><a href="' + product.url + '">' + product.title + '</a></h3></div></td>';
                  var second_column = '<td><div class="wishlist-product__price">' + Shopify.formatMoney(product.price) + '</div></td>';
                  if(product.available) {
                    var third_column = '<td><div class="wishlist-product__status wishlist-product__status--in-stock">' + $(".js-wishlist-body").attr("data-in-stock") + '</div></td>';
                  } else {
                    var third_column = '<td><div class="wishlist-product__status wishlist-product__status--stock-out">' + $(".js-wishlist-body").attr("data-out-of-stock") + '</div></td>';
                  }
                  var fourth_column = '<td><a href="' + product.url + '" class="sixth-button">' + $(".js-wishlist-body").attr("data-add-to-cart") + '</a></td>';
                  var fifth_column = '<td><div class="wishlist-product__delete"><a href="#" class="js-delete-product-wishlist" data-product-handle="' + product.handle + '"><i class="lnil lnil-close"></i></a></div></td>';
                  wishlistContent = wishlistContent + '<tr>' + first_column + '' + second_column + '' + third_column + '' + fourth_column + '' + fifth_column + '</tr>';
                });
              }
            }
          }
          setTimeout(function () {
            if(wishlistContent == '') {
              wishlistContent = '<tr><td colspan="5">' + $(".js-wishlist-body").attr("data-wishlist-empty") + '</td></tr>';
              $(".js-wishlist-body").html(wishlistContent);
            } else {
              $(".js-wishlist-body").html(wishlistContent);
            }
          }, 2000);
          $("body").on("click", ".js-delete-product-wishlist", function() {
            $(this).parent().parent().parent().remove();
            var productHandle = $(this).attr("data-product-handle");
            var getWishlistProducts = localStorage.getItem('wishlist');
            if(getWishlistProducts == null) { getWishlistProducts = ''; }
            getWishlistProducts = getWishlistProducts.replace(productHandle + ",", "");
            localStorage.setItem('wishlist', getWishlistProducts);
            return false;
          });
        }
        var wishlist = localStorage.getItem('wishlist');
        if(wishlist == null) { wishlist = ''; }
        var wishlistCounter = wishlist.split(",").length - 1;
        if(wishlistCounter < 0) { wishlistCounter = 0; }
        $(".js-wishlist-count").html(wishlistCounter);
      },

      compare: function() {
        $(".js-add-to-compare").each(function () {
          var productHandle = $(this).attr("data-product-handle") + ",";
          var compare = localStorage.getItem('compare');
          if(compare == null) { compare = ''; }
          if(compare.indexOf(productHandle) >= 0) {
            $(this).addClass("compared");
            $(this).find("span").html($(this).attr("data-added"));
          }
        });
        $("body").on("click", ".js-add-to-compare", function () {
          if(!$(this).hasClass("compared")) {
            var productHandle = $(this).attr("data-product-handle");
            $(this).find("span").html($(this).attr("data-added"));
            var getComparedProducts = localStorage.getItem('compare');
            if(getComparedProducts == null) { getComparedProducts = ''; }
            getComparedProducts = getComparedProducts.replace(productHandle + ",", "");
            localStorage.setItem('compare', getComparedProducts + productHandle + ",");
            $(this).addClass("compared");
            return false;
          }
        });
        if($(".js-compare-body").length > 0) {
          var compare = localStorage.getItem('compare');
          var compareContent = '';
          if(compare == null) { compare = ''; }
          if(compare != '') {
            var compareProducts = compare.split(",");
            for (let i = 0; i < compareProducts.length; i++) {
              if(compareProducts[i] != '') {
                jQuery.getJSON('/products/' + compareProducts[i] + '.js', function (product) {
                  var first_column = '<td><div class="wishlist__product"><div class="wishlist-product__image"><a href="' + product.url + '"><img alt="Image" data-sizes="auto" data-srcset="' + product.featured_image + ' 400w" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload" /></a></div><h3 class="wishlist-product__title"><a href="' + product.url + '">' + product.title + '</a></h3></div></td>';
                  var second_column = '<td><div class="wishlist-product__price">' + Shopify.formatMoney(product.price) + '</div></td>';
                  if(product.available) {
                    var third_column = '<td><div class="wishlist-product__status wishlist-product__status--in-stock">' + $(".js-compare-body").attr("data-in-stock") + '</div></td>';
                  } else {
                    var third_column = '<td><div class="wishlist-product__status wishlist-product__status--stock-out">' + $(".js-compare-body").attr("data-out-of-stock") + '</div></td>';
                  }
                  var fourth_column = '<td><a href="' + product.url + '" class="sixth-button">' + $(".js-compare-body").attr("data-add-to-cart") + '</a></td>';
                  var fifth_column = '<td><div class="wishlist-product__delete"><a href="#" class="js-delete-product-compare" data-product-handle="' + product.handle + '"><i class="lnil lnil-close"></i></a></div></td>';
                  compareContent = compareContent + '<tr>' + first_column + '' + second_column + '' + third_column + '' + fourth_column + '' + fifth_column + '</tr>';
                });
              }
            }
          }
          setTimeout(function () {
            if(compareContent == '') {
              compareContent = '<tr><td colspan="5">' + $(".js-compare-body").attr("data-compare-empty") + '</td></tr>';
              $(".js-compare-body").html(compareContent);
            } else {
              $(".js-compare-body").html(compareContent);
            }
          }, 2000);
          $("body").on("click", ".js-delete-product-compare", function() {
            $(this).parent().parent().parent().remove();
            var productHandle = $(this).attr("data-product-handle");
            var getCompareProducts = localStorage.getItem('compare');
            if(getCompareProducts == null) { getCompareProducts = ''; }
            getCompareProducts = getCompareProducts.replace(productHandle + ",", "");
            localStorage.setItem('compare', getCompareProducts);
            return false;
          });
        }
      },

      sizeGuide: function() {
        $(".js-open-size-guide").click(function () {
          $(".js-size-guide-popup").addClass("active");
          return false;
        });
        $(".js-close-size-guide-popup").click(function () {
          $(".js-size-guide-popup").removeClass("active");
          return false;
        });
      },

      refreshCart: function() {
        $('#cart-content').load('/cart #cart-content', function() {
          $(".js-canvas-cart").addClass("active");
          $(".js-add-to-cart, .js-add-to-cart-sticky").removeClass("is-loading");
          $(".js-cart-content").removeClass("is-loading");
        });
        $('#cart-content-2').load('/cart #cart-content-2', function() {
        });
        jQuery.getJSON('/cart.js', function(cart) {
          $('.js-cart-count').html(cart.item_count);
          $('.js-cart-price').html(Shopify.formatMoney(cart.total_price));
        });
      },

      refreshCartDefault: function() {
        $('#cart-content-2').load('/cart #cart-content-2', function() {
          $(".js-add-to-cart, .js-add-to-cart-sticky").removeClass("is-loading");
          $(".js-cart-content").removeClass("is-loading");
        });
        $('#cart-content').load('/cart #cart-content', function() {
        });
        jQuery.getJSON('/cart.js', function(cart) {
          $('.js-cart-count').html(cart.item_count);
          $('.js-cart-price').html(Shopify.formatMoney(cart.total_price));
        });
      },

      quickView: function() {
        $("body").on("click", ".js-quick-view", function () {
          $(".js-quickview-popup").addClass("active");
          $('#quickview-product').addClass("d-none");
          $(".js-quickview-loader").removeClass("d-none");
          var productUrl = $(this).attr("data-product-url");
          $('#quickview-product').load(productUrl + ' #product-quickview-content', function() {
            $(".js-quickview-loader").addClass("d-none");
            $(this).removeClass("d-none");
            $(this).find("#product-quickview-content").removeClass("d-none").addClass("d-flex");
            ebere.productMobileImages();
            ebere.productForm();
          });
          return false;
        });
        $(".js-close-quickview-popup").click(function () {
          $(".js-quickview-popup").removeClass("active");
          return false;
        });
      }
    }
  })();
})(jQuery);

$(document).ready(function() {
  ebere.init();
});

if (window.Shopify.designMode) {
  jQuery(document)
    .on('shopify:section:load', function() {
      ebere.init();
    }).on('shopify:section:unload', function() {
      ebere.init();
    }).on('shopify:section:select', function() {
      ebere.init();
    }).on('shopify:section:deselect', function() {
      ebere.init();
    }).on('shopify:block:select', function() {
      ebere.init();
    }).on('shopify:block:deselect', function() {
      ebere.init();
    });
}
document.addEventListener("DOMContentLoaded", function() {
  const breadcrumbTrail = document.getElementById('breadcrumb-trail');
  const homeLink = document.createElement('a');
  homeLink.href = '/';
  homeLink.title = 'Home';
  homeLink.innerText = 'Home';

  const collectionsLink = document.createElement('a');
  collectionsLink.href = '/collections';
  collectionsLink.title = 'Collections';
  collectionsLink.innerText = 'Collections';

  // Sub-collection pages
  const subCollections = {
      '/pages/wedding-collection': 'Wedding Collection',
      '/pages/kids-collection': 'Kids Collection',
      '/pages/brand-collection': 'Brand Collection',
      '/pages/home-collection': 'Home Collection'
  };

  // Function to update the breadcrumb trail
  function updateBreadcrumb() {
      const currentPath = window.location.pathname;
      let storedBreadcrumbs = ['/collections']; // Always keep collections as second breadcrumb

      if (currentPath === '/collections') {
          localStorage.removeItem('lastSubCollection'); // Clear sub-collection when on collections page
      }

      const lastCollection = localStorage.getItem('lastSubCollection');

      // If on a sub-collection page, store it
      if (subCollections[currentPath]) {
          storedBreadcrumbs.push(currentPath);
          localStorage.setItem('lastSubCollection', currentPath); // Store the sub-collection
      } else if (lastCollection && subCollections[lastCollection] && currentPath !== '/collections') {
          // Always keep last sub-collection if one exists and we're not on collections page
          storedBreadcrumbs.push(lastCollection);
      }

      // If on a product page, add the product
      if (currentPath.startsWith('/products/')) {
          storedBreadcrumbs.push(currentPath);
      }

      localStorage.setItem('breadcrumbs', JSON.stringify(storedBreadcrumbs));

      // Build and display breadcrumb trail
    if(breadcrumbTrail!== null){
       breadcrumbTrail.innerHTML = ''; // Clear existing breadcrumbs
    }
     

      // Add Home link
      const homeItem = document.createElement('li');
      homeItem.classList.add('breadcrumb__item');
      homeItem.appendChild(homeLink);
      breadcrumbTrail.appendChild(homeItem);

      // Add stored breadcrumbs
      storedBreadcrumbs.forEach(path => {
          const listItem = document.createElement('li');
          listItem.classList.add('breadcrumb__item');

          const link = document.createElement('a');
          link.href = path;
          link.innerText = subCollections[path] || formatBreadcrumbName(path.split('/').pop());
          listItem.appendChild(link);

          breadcrumbTrail.appendChild(listItem);
      });
  }

  // Function to format the breadcrumb name
  function formatBreadcrumbName(pathName) {
      return pathName.charAt(0).toUpperCase() + pathName.slice(1).toLowerCase().replace(/-/g, ' ');
  }

  // Handle breadcrumb link clicks
 // if (breadcrumbTrail !== null){
     breadcrumbTrail.addEventListener('click', function(event) {
      if (event.target.tagName === 'A') {
          const clickedPath = event.target.getAttribute('href');
          if (clickedPath === '/') {
              // Clear local storage and reset breadcrumbs
              localStorage.removeItem('breadcrumbs');
              localStorage.removeItem('lastSubCollection');
              updateBreadcrumb();
          } else {
              // Navigate to the clicked path and update breadcrumbs
              let storedBreadcrumbs = JSON.parse(localStorage.getItem('breadcrumbs')) || [];
              const index = storedBreadcrumbs.indexOf(clickedPath);
              if (index !== -1) {
                  storedBreadcrumbs = storedBreadcrumbs.slice(0, index + 1);
                  localStorage.setItem('breadcrumbs', JSON.stringify(storedBreadcrumbs));
                  window.location.href = clickedPath; // Navigate to the clicked path
              }
          }
      }
  });
 // }
 

  // Handle nav__item clicks
  document.querySelectorAll('.nav__item').forEach(function(navItem) {
      navItem.addEventListener('click', function(event) {
          // Prevent default navigation
          event.preventDefault();

          // Clear local storage and serve default breadcrumbs "Home / Collections"
          localStorage.removeItem('breadcrumbs');
          localStorage.removeItem('lastSubCollection');
          breadcrumbTrail.innerHTML = ''; // Clear existing breadcrumbs

          // Add Home link
          const homeItem = document.createElement('li');
          homeItem.classList.add('breadcrumb__item');
          homeItem.appendChild(homeLink);
          breadcrumbTrail.appendChild(homeItem);

          // Add Collections link
          const collectionsItem = document.createElement('li');
          collectionsItem.classList.add('breadcrumb__item');
          console.log('test', collectionsLink);
          collectionsItem.appendChild(collectionsLink);
          breadcrumbTrail.appendChild(collectionsItem);

          // Delay navigation to ensure breadcrumbs update first
          const targetHref = navItem.getAttribute('href');
          if (targetHref) {
              setTimeout(function() {
                  window.location.href = targetHref;
              }, 100); // Delay navigation by 100 milliseconds
          }
      });
  });

  // Initialize breadcrumb trail
  updateBreadcrumb();
});

document.addEventListener('DOMContentLoaded', function() {
        // Get all input fields with class 'js-custom-input'
        var inputs = document.querySelectorAll('.js-custom-input');

        inputs.forEach(function(input) {
            // Get the corresponding character count span
            var charCountSpan = document.querySelector('#char-count_' + input.id.split('_')[1]);
            var maxLength = input.getAttribute('data-max-length');

            // Set the maxlength attribute dynamically
            input.setAttribute('maxlength', maxLength);

            function updateCharCount() {
                var currentLength = input.value.length;
              if(charCountSpan !== null){
                charCountSpan.textContent = currentLength + '/' + maxLength;
              }
                
            }

            // Initialize the character count on page load
            updateCharCount();

            // Update the character count on input
            input.addEventListener('input', updateCharCount);
        });
    });

document.addEventListener('DOMContentLoaded', function() {
        var customFields = document.querySelectorAll('.product__right .custom_fields');
        // for (var i = 1; i < customFields.length; i++) {
        //     customFields[i].style.marginTop = '-25px'; // Adjust the margin as needed
        // }
    });
$(document).ready(function() {
    console.log('DOM fully loaded and parsed');

    // Function to show or hide error messages based on input
    function checkFields() {
        let allFilled = true;

        $('.js-custom-input').each(function() {
            const $input = $(this);
            const $errorMessage = $input.closest('.custom_fields').find('.error-message'); // Select the error message

            if ($input.val().trim() === '') {
                $errorMessage.show(); // Show error message
                allFilled = false;
            } else {
                $errorMessage.hide(); // Hide error message
            }
        });

        $('#add-to-cart-button').prop('disabled', !allFilled); // Enable or disable the button based on field validation
    }

    // Event listeners for input fields
    $('.js-custom-input').on('input', checkFields);

    // Handle the Add to Cart button click
    $('#add-to-cart-button').on('click', function(event) {
        checkFields(); // Ensure fields are checked on button click

        if ($(this).prop('disabled')) {
            console.log('Button is disabled. Preventing default action.');
            event.preventDefault(); // Prevent default action if button is disabled
            return false; // Prevent the default action
        }
    });

    // Initial check to set the correct button state
    //checkFields();
});

// slideable banners
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".cstm-slidable-banner .row");
  const dotsContainer = document.querySelector(".cstm-slider-dots");
  const slides = document.querySelectorAll(".cstm-slidable-banner .col-lg-3");
  let currentIndex = 0;

  // Create dots dynamically
  slides.forEach((_, index) => {
    const dot = document.createElement("span");
    if (index === 0) dot.classList.add("active");
    dot.addEventListener("click", () => {
      slider.scrollTo({
        left: index * slider.clientWidth,
        behavior: "smooth",
      });
    });
    dotsContainer.appendChild(dot);
  });

  const dots = document.querySelectorAll(".cstm-slider-dots span");

  // Sync active dot with scrolling
  if(slider !== null){
     slider.addEventListener("scroll", () => {
    let newIndex = Math.round(slider.scrollLeft / slider.clientWidth);
    if (newIndex !== currentIndex) {
      dots[currentIndex].classList.remove("active");
      dots[newIndex].classList.add("active");
      currentIndex = newIndex;
      }
    });
  }
 
});
// slideable Reviews 
// document.addEventListener("DOMContentLoaded", function () {
//   const slider = document.querySelector(".cstm-slidable-reviews .row");
//   const dotsContainer = document.querySelector("#cstm-slider-dots-reviews");
//   const slides = document.querySelectorAll(".cstm-slidable-reviews .col-lg-3");
//   let currentIndex = 0;

//   // Create dots dynamically
//   slides.forEach((_, index) => {
//     console.log("creating dots");
//     const dot = document.createElement("span");
//     if (index === 0) dot.classList.add("active");
//     dot.addEventListener("click", () => {
//       slider.scrollTo({
//         left: index * slider.clientWidth,
//         behavior: "smooth",
//       });
//     });
//     dotsContainer.appendChild(dot);
//   });

//   const dots = document.querySelectorAll("#cstm-slider-dots-reviews span");

//   // Sync active dot with scrolling
//   if(slider !== null){
//      slider.addEventListener("scroll", () => {
//     let newIndex = Math.round(slider.scrollLeft / slider.clientWidth);
//     if (newIndex !== currentIndex) {
//       dots[currentIndex].classList.remove("active");
//       dots[newIndex].classList.add("active");
//       currentIndex = newIndex;
//       }
//     });
//   }
 
// });
// Scroll header color change
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header.header--type-7");
  const targetSection = document.querySelector("#shopify-section-template--20939137777700__shoppable_slider_banners_wJ8Lpi"); // Change to your section class or ID

  window.addEventListener("scroll", function () {
    if(targetSection !== null){
        const sectionTop = targetSection.offsetTop;
    const scrollPosition = window.scrollY;

    if (scrollPosition >= sectionTop - 50) { // Adjust threshold if needed
      header.classList.add("cstm-scrolled");
    } else {
      header.classList.remove("cstm-scrolled");
    }
    }
  
  });
});
// addon in cart display
// pic upload


  document.addEventListener("DOMContentLoaded", function () {
    let uploadBox = document.getElementById("uploadBox");
    let fileInput = document.getElementById("customImageUpload");
    let filePreview = document.getElementById("filePreview");
    let removeBtn = document.getElementById("removeImageBtn");

    function updatePreview(file) {
      if (file) {
        const reader = new FileReader();
        reader.onload = function (e) {
          filePreview.innerHTML = `
            <img src="${e.target.result}" alt="Uploaded Image">
            <button type="button" class="cstm-remove-icon" id="removeImageBtn"><i class="lnir lnir-trash"></i></button>
          `;
          filePreview.style.display = "block";

          // Reattach event listener after updating preview
          document.getElementById("removeImageBtn").addEventListener("click", function () {
            fileInput.value = ""; // Reset file input
            filePreview.innerHTML = ""; // Clear preview
            filePreview.style.display = "none";
          });
        };
        reader.readAsDataURL(file);
      }
    }

    fileInput.addEventListener("change", function () {
      if (fileInput.files.length > 0) {
        updatePreview(fileInput.files[0]);
      }
    });

    uploadBox.addEventListener("dragover", function (e) {
      e.preventDefault();
      uploadBox.style.borderColor = "#3a82f6";
    });

    uploadBox.addEventListener("dragleave", function () {
      uploadBox.style.borderColor = "#ccc";
    });

    uploadBox.addEventListener("drop", function (e) {
      e.preventDefault();
      let file = e.dataTransfer.files[0];
      fileInput.files = e.dataTransfer.files;
      updatePreview(file);
      uploadBox.style.borderColor = "#ccc";
    });
  });
// addon 
document.addEventListener('DOMContentLoaded', function () {
    //const addonVariantId = 42214905806884; // Replace this with your real variant ID
    const addonToggle = document.getElementById('addon-switch');
    const addonInput = document.getElementById('addon-switch');
    const addonPrice = document.getElementById('cstm-addon-price');
    var addonVariantId = 0;
  if(addonInput !== null){
     addonVariantId = addonInput.getAttribute('data-addon-id');
  }
    
    const addonDesc = document.getElementById('cstm-addon-description');
    //console.log("IDd",addonVariantId);
    addonToggle.addEventListener('change', function () {
      addonToggle.disabled = true;
      if (this.checked) {
        // Add the addon product to cart
        addonPrice.style.display = 'block';
        addonDesc.style.display = 'block';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: addonVariantId,
            quantity: 1
          })
        })
        .then(response => response.json())
        .finally(() => {
            console.log('addon added');
            addonToggle.disabled = false; // re-enable after response
          });
      } else {    
        // Remove addon product from cart
        addonPrice.style.display = 'none';
        addonDesc.style.display = 'none';
        
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: addonVariantId,
                  quantity: 0
                })
              })
              .then(res => res.json())
              .finally(() => {
                  console.log('addon removed');
                  addonToggle.disabled = false; // re-enable after response
                })
      }
    });
  });
// Multiple addons
document.addEventListener('DOMContentLoaded', function () {
  const addonToggles = document.querySelectorAll("input[type='checkbox'][id^='addon-switch']");

  addonToggles.forEach(function (toggle) {
    const addonId = toggle.getAttribute('data-addon-id');
    const priceElement = document.getElementById(`cstm-addon-price-${addonId}`);
    const descElement = document.getElementById(`cstm-addon-description-${addonId}`);

    toggle.addEventListener('change', function () {
      toggle.disabled = true;

      if (this.checked) {
        // Show UI
        if (priceElement) priceElement.style.display = 'block';
        if (descElement) descElement.style.display = 'block';

        // Add to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: addonId,
            quantity: 1
          })
        })
        .then(response => response.json())
        .finally(() => {
          console.log(`Addon ${addonId} added`);
          //updateCartDrawer();
          //updateHeaderCart();

          toggle.disabled = false;
        });

      } else {
        // Hide UI
        if (priceElement) priceElement.style.display = 'none';
        if (descElement) descElement.style.display = 'none';

        // Remove from cart
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: addonId,
            quantity: 0
          })
        })
        .then(response => response.json())
        .finally(() => {
          console.log(`Addon ${addonId} removed`);
         updateCartDrawer();
         updateHeaderCart();

          toggle.disabled = false;
        });
      }
    });
  });
});

//End Multiple Addons
 document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.cstm-review-slider', {
      slidesPerView: 1,
      spaceBetween: 40,
       pagination: {
          el: '.swiper-pagination',
          clickable: true, 
        },
      // navigation: {
      //   nextEl: '.cstm-arrow-right',
      //   prevEl: '.cstm-arrow-left',
      // },
      breakpoints: {
        768: {
          slidesPerView: 3,
        }
      }
    });
  });

// Update header cart
function updateHeaderCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update count
      const countEls = document.querySelectorAll('.js-cart-count');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
      });

      // Update subtotal
      const priceEls = document.querySelectorAll('.js-cart-price');
      priceEls.forEach(el => {
        el.textContent = Shopify.formatMoney
          ? Shopify.formatMoney(cart.total_price, Shopify.money_format)
          : formatMoney(cart.total_price);
      });
    });
}
// Update cart drawer cart
function updateCartDrawer() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // 1️⃣ Update Cart Title Count (Cart (X))
      const cartHeading = document.querySelector('.canvas-cart__h3');
      if (cartHeading) {
        cartHeading.textContent = `Cart (${cart.item_count})`;
      }

      // 2️⃣ Update Subtotal
      const subtotal = document.querySelector('.subtotal__value');
      if (subtotal) {
        subtotal.textContent = Shopify.formatMoney
          ? Shopify.formatMoney(cart.total_price, Shopify.money_format)
          : formatMoney(cart.total_price); // fallback
      }

      // 3️⃣ Update Cart Items
      const cartList = document.querySelector('.header-cart__items');
      if (cartList) {
        cartList.innerHTML = ''; // Clear current items

        cart.items.forEach(item => {
          const li = document.createElement('li');
          li.className = 'cart-item d-flex';

          li.innerHTML = `
            <!-- Item image -->
            <p class="cart-item__image">
              <a href="${item.url}">
                <img src="${item.image}" alt="${item.product_title}" width="60" height="60">
              </a>
            </p>
            <!-- Item details -->
            <p class="cart-item__details">
              <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
              ${item.variant_title !== 'Default Title' ? `<span class="cart-item__variant">${item.variant_title}</span>` : ''}
              <span class="cart-ietm__price">${item.quantity} <i>x</i> ${Shopify.formatMoney ? Shopify.formatMoney(item.price, Shopify.money_format) : formatMoney(item.price)}</span>
            </p>
            <!-- Quantity -->
            <div class="cart-item__quantity">
              <div class="cart-product__quantity-field">
                <div class="quantity-field__minus js-change-quantity" data-variant-id="${item.variant_id}" data-quantity="${item.quantity - 1}"><a href="#">-</a></div>
                <input type="text" value="${item.quantity}" class="quantity-field__input" disabled="disabled">
                <div class="quantity-field__plus js-change-quantity" data-variant-id="${item.variant_id}" data-quantity="${item.quantity + 1}"><a href="#">+</a></div>
              </div>
            </div>
            <!-- Delete -->
            <p class="cart-item__delete">
              <a href="#" class="js-delete-product-canvas" data-variant-id="${item.variant_id}"><i class="lnil lnil-close"></i></a>
            </p>
          `;

          cartList.appendChild(li);
        });
      }
    });
}
// only addon...
 
  document.addEventListener('DOMContentLoaded', function () {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.items.length === 0) return; // nothing in cart
          console.log("items in cart");
        const productFetches = cart.items.map(item => {
          return fetch(`/products/${item.handle}.js`)
            .then(res => res.json())
            .then(product => ({
              key: item.key,
              title: product.title,
              tags: product.tags,
              isAddon: product.tags.includes('Addon'),
              quantity: item.quantity
              
            }));
        });

        Promise.all(productFetches).then(products => {
           //const t = products.every(p => p.title);
          
          const onlyAddons = products.every(p => p.isAddon);
          console.log("iss adon", onlyAddons)

          
          products.forEach(item => {
            console.log("item", item);
            if (item.isAddon && item.quantity > 1) {
              // ✅ Enforce quantity = 1 for addons
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 1 })
              });
                updateCartDrawer();
              updateHeaderCart();
            }
          });
          
          if (onlyAddons) {
            // Option: Disable checkout
            const checkoutButton = document.querySelector('[name="checkout"]');
            if (checkoutButton) checkoutButton.disabled = true;

            // Optional: Auto-remove addon items from cart
            products.forEach(item => {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 0 })
              });
              updateCartDrawer();
              updateHeaderCart();
            });

            // Optional: Show message
            const warning = document.createElement('p');
            warning.style.color = 'red';
            warning.textContent = 'Add-ons cannot be purchased alone. Please add a main product.';
            document.querySelector('form[action="/cart"]')?.prepend(warning);
          }
        });
      });
  });




 


